"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _firebaseHooks = require("@rainbow-modules/firebase-hooks");

var _getRedirectTo = _interopRequireDefault(require("../../helpers/getRedirectTo"));

var Private = function Private(props) {
  // eslint-disable-next-line react/prop-types
  var location = props.location,
      component = props.component,
      redirect = props.redirect,
      children = props.children,
      rest = (0, _objectWithoutProperties2["default"])(props, ["location", "component", "redirect", "children"]);
  var isAuth = (0, _firebaseHooks.useAuthState)();
  var Component = component;

  if (isAuth === false) {
    if (Component) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
        location: location
      }, rest));
    }

    return children;
  }

  if (isAuth) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
      to: (0, _getRedirectTo["default"])({
        redirect: redirect,
        location: location
      })
    });
  }

  return null;
};

var WhenNoAuthenticated = function WhenNoAuthenticated(props) {
  var path = props.path,
      redirect = props.redirect,
      component = props.component,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: path,
    render: function render() {
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        _react["default"].createElement(Private, (0, _extends2["default"])({}, rest, {
          redirect: redirect,
          component: component
        }), children)
      );
    }
  });
};

WhenNoAuthenticated.propTypes = {
  path: _propTypes["default"].string,
  component: _propTypes["default"].func,
  redirect: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  children: _propTypes["default"].node
};
WhenNoAuthenticated.defaultProps = {
  path: '',
  component: undefined,
  redirect: undefined,
  children: null
};
var _default = WhenNoAuthenticated;
exports["default"] = _default;